<script>
    import SiteHeader from './SiteHeader'
    import Login from '$modals/Login'
    import ProSelect from '$common/ProSelect'
    import ArrowDownIcon from 'vue-material-design-icons/ArrowDown.vue';

    export default {
        name: 'Index',
        components: {
            SiteHeader,
            Login,
            ProSelect,
            ArrowDownIcon
        },
        data() {
            return {
                mykey: 'bar',
                locations: ["a", "b"],
                hoverEdu: false,
                hoverIndustry: false,
                showLogin: false,
                publicPath: process.env.BASE_URL,
                user: ""
            }
        },
        methods: {
          dismissModal(){
            var bodyElement = document.getElementsByTagName('body')[0];
            bodyElement.style.overflow = "auto"

            console.log("got it.  turning off")
            this.showLogin = false
          },
          displayLogin(){
            
            var bodyElement = document.getElementsByTagName('body')[0];
            bodyElement.style.overflow = "hidden"

            this.user = this.$store.getters.user
            console.log(this.user)            
            if (this.user) {
              this.decideNextRoute(this.user)
            } else {
              this.showLogin = true
            }
          },
          scrollDown () {
            // https://stackoverflow.com/questions/40730116/scroll-to-bottom-of-div-with-vue-js
            var el = this.$el.querySelector("#detail-content");

            // might just need to pass false if IE11.  browser check
            el.scrollIntoView({behavior: "smooth", block: "end"})

          },
          decideNextRoute (user) {
              var bodyElement = document.getElementsByTagName('body')[0];
              bodyElement.style.overflow = "auto"
              if ( !user.approved ) {
                return this.$router.push({name: 'awaitingApproval'})
              } else {

                const defaultRoute = {
                    Educator: 'educator',
                    Company: 'industry',
                }[user.userRec.type]

                if (defaultRoute === this.$route.name) return //don't want to have a duplicate route error

                this.$router.push({name: defaultRoute})
              }

          }                   
        }
        
    }
</script>

<template lang="pug">
    .foo
        site-header( @displayLogin="displayLogin" )
        login(v-if="showLogin" @dismissModal="dismissModal")
        #more-info-container
          #more-info(@click="scrollDown")
            .details Learn More
            arrow-down-icon.arrow-down
        #portal-container.row
            #educ_div.holder_div.col.s12.l6( @mouseover="hoverEdu=true" @mouseleave="hoverEdu=false")
                #educ_default.default_div( v-bind:class="{ 'invisible': hoverEdu }")
                    h3 EDUCATOR PORTAL
                #educ_hover.col.s10.offset-s1.hover_div( v-bind:class="{ 'visible': hoverEdu }")
                    h3  EDUCATOR PORTAL
                    p
                        | Are you an educator seeking to expand your students’ awareness of career opportunities in a variety of businesses and connect them to area professionals? Do you want students to learn more about the education and training pathways that lead to high-demand jobs and meaningful work? Enter through the Educator Portal to set up a profile and find businesses looking to share their knowledge to support your efforts and your students!
                    a#educ_btn.button.modal-trigger(data-target='login' href="#" @click="displayLogin()") ENTER
            #industry_div.holder_div.col.s12.l6( @mouseover="hoverIndustry=true" @mouseleave="hoverIndustry=false")
                #industry_default.default_div( v-bind:class="{ 'invisible': hoverIndustry }")
                    h3 INDUSTRY PORTAL
                #industry_hover.col.s10.offset-s1.hover_div( v-bind:class="{ 'visible': hoverIndustry }")
                    .hover-container
                      h3  INDUSTRY PORTAL
                      p
                          | Are you an employer seeking to create awareness about your business and the skills and experience students need to succeed in your industry? Are you interested in hiring students for summer or part-time jobs or supporting educators, as a classroom speaker or through a job shadow experience? Enter through the Industry Portal to set up a profile and share the ways you and your business can connect with students and educators!
                      a#industry_btn.button.modal-trigger(data-target='login' href="#" @click="displayLogin()") ENTER        
        //- .public-main-main( @click='foo') hello {{mykey}}
        .spacer
        .row#detail-content
            #box1.col.s6.l4.boxes
            //- a(href='resources/Community_Resources.pdf')#box2.col.s6.l4.boxes.valign-wrapper
            a(href="/IndustyConnectEDEngagementOptions.pdf" target="_blank")#box2.col.s6.l4.boxes.valign-wrapper
                .center-align(style='width:100%')
                    h5.box-text.valign
                      | OPPORTUNITIES
                      br
                      | TO CONNECT
            #box3.col.s6.l4.boxes
            a(href='https://www.sbrchamber.com/events/workforce/' target="_blank")#box4.col.s6.l4.valign-wrapper.boxes
                .center-align(style='width:100%')
                    h5.box-text.valign  EVENTS
            #box3_s.col.s6.l4.boxes.hide
            #box5.col.s6.l4.boxes
            a(href='/about')#box6.col.s6.l4.boxes.valign-wrapper
                .center-align(style='width:100%')
                    h5.box-text.valign  ABOUT
</template>

<style lang="sass" scoped>

@import '$vars'

@media screen and (max-width: 1020px)
  #more-info-container
    display: none

#more-info-container
  position: relative;
  top: 65vh;
  z-index: 3000
  height: 0px
  width: 100vw
  text-align: center

#more-info:hover
  background-color: #CCCCCC

#more-info
  position: relative
  z-index: 3000
  margin: 0 auto
  width: 120px
  height: 120px
  border-radius: 60px
  //background-color: #777777
  background-color: white
  text-align: center
  color: black
  cursor: pointer
  .details
    position: relative
    top: 30px
  .arrow-down
    font-size: 3em
    margin: 0 auto
    top: 25px
    position: relative

#industry_btn, #educ_btn
  padding-top: 5px

.box-text
    font-size: 2em

.foo
    background-color: white

.spacer
    height: 50px

#educ_btn:hover
    background-color: white
    color: $chamber-orange

#industry_btn:hover
    background-color: white
    color: #33404f

#educ_div
	background-color: $chamber-orange

#industry_div
	background-color: #33404f

.invisible
    display: none

.visible
    opacity: 1 !important

.holder_div
	color: #fff;
	padding: 0 !important;
	height: 90vh;
	min-height: 500px !important;
	text-align: center;
	transition: .3s;
	position: relative;


.hover_div
	text-align: left;
	position: absolute;
	height: 100%;
	width: 100%;
	z-index: 50;
	opacity: 0;
	transition: .5s;

.hover_div
    h3
        margin-top: 15vh;
        padding: 0;
        // padding-bottom: .5em;
        text-align: left;
        color: #fff !important;


.hover_div
    p
        text-align: left
        // margin: 4em 4em 2em 4em;
        color: #fff;
        // padding-bottom: 2em;
        font-size: 16px;
 

.visible
    opacity: 100 !important

.default_div
	padding-top: 15em;
	position: absolute;
	height: 100%;
	width: 100%;
	transition: .5s;


#educ_default 
	background-image: url("~@/assets/1_educatorportal.jpg");
	background-position: center center;
	background-size: cover;
	background-repeat: no-repeat;


#industry_default 
	background-image: url("~@/assets/2_industryportal.jpg");
	background-position: center center;
	background-size: cover;
	background-repeat: no-repeat;


.hover_div 
    h3
        padding-top: 1.5em;


.button
	border: 1px solid #fff;
	color: #fff;
	padding: .75em 4em .75em 4em;



// BOXES //

.boxes
	padding: 0 !important;
	color: white;
	background-position: center center;
	background-size: cover;
	background-repeat: no-repeat;


#box1
	height: 26.25vw;
	background-image: url("~@/assets/externship.jpg");


#box2
	height: 26.25vw;
	background-color: #008aad;
	vertical-align: middle;

#box3, #box3_s 
	height: 26.25vw;
	background-image: url("~@/assets/5.jpg");

#box4
	height: 26.25vw;
	background-color: $chamber-orange
	vertical-align: middle;

#box5
	background-color: $chamber-orange
	height: 26.253vw;
	background-image: url("~@/assets/3.jpg");

#box6
	height: 26.25vw;
	background-color: #33404f
	vertical-align: middle;

</style>
